export default String.raw`
<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{translations.Orders}}
	</div>
	<div class="change-container">
		{% if settings.erpOrdersAvailability == 'yes' and config.B2B %}
			{% if page.QueryString contains 'tab=erp-orders' -%}
				{% assign activeErp = true -%}
			{% else -%}
				{% assign activeErp = false -%}
			{% endif -%}
			<div class="change-container__type">
				<button class="change-type-js change-orders-source-js parent-container-reload-js load-erp-data-js change-container__type text {% if activeErp == false -%} active {% endif -%}" data-url="{{ page.Url }}?tab=eshop-orders">{{ translations.B2BShop }}</button>
			</div>
			<div class="change-container__type">
				<button class="change-type-js change-orders-source-js parent-container-reload-js load-erp-data-js change-container__type text {% if activeErp -%} active {% endif -%}" data-url="{{ page.Url }}?tab=erp-orders">{{ translations.OtherSales }}</button>
			</div>
		{% endif -%}
		{% if config.B2B == false %}
			{% if page.QueryString contains 'tab=executed-orders' -%}
				{% assign executedOrders = true -%}
			{% else -%}
				{% assign executedOrders = false -%}
			{% endif -%}
			<div class="change-container__type">
				<button class="change-type-js change-orders-source-js parent-container-reload-js change-container__type text {% if executedOrders == false -%} active {% endif -%}" data-url="{{ page.Url }}?tab=active-orders">{{ translations.UnderExecution }}</button>
			</div>
			<div class="change-container__type">
				<button class="change-type-js change-orders-source-js parent-container-reload-js change-container__type text {% if executedOrders -%} active {% endif -%}" data-url="{{ page.Url }}?tab=executed-orders">{{ translations.Executed }}</button>
			</div>
		{% endif -%}
		<div class="slider"></div>
	</div>
	<div class="orders-js container-js" data-template="partials/common/order-details.html">
		{% include 'partials/customer-profile/orders/orders-list.html' -%}
	</div>
</div>
`